import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsFullWidthContentLayout } from 'modules/settings/components/settings-fullwidth-content-layout/settings-fullwidth-content-layout.component';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { settingsModulePaths } from 'core/routes/routes';
import { SettingsMaterialDefinitionsListContainer } from '../settings-material-definitions-list/settings-material-definitions-list.container';
import { MaterialDefinitionsListProvider } from 'modules/settings/contexts/material-definitions/material-definitions-list.provider';
import { MaterialDefinitionsBulkActionsContainer } from '../settings-material-definitions-bulk-actions/material-definitions-bulk-actions.container';

export const SettingsMaterialDefinitionsDashboardContainer: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const handleAddNew = () => {
        navigate(settingsModulePaths.materialDefinitionsForm.replace(':materialDefinitionId', 'new'));
    };

    return (
        <MaterialDefinitionsListProvider>
            <SettingsFullWidthContentLayout
                title={t('settings.materials.material-definitions.title')}
                description={t('settings.materials.material-definitions.subtitle')}
                scrollContainerRef={scrollContainerRef}
                actionsContent={
                    <PocButton variant="secondary" onClick={handleAddNew}>
                        {t('settings.materials.material-definitions.add-button')}
                    </PocButton>
                }
                extraContent={<MaterialDefinitionsBulkActionsContainer />}
            >
                <SettingsMaterialDefinitionsListContainer scrollContainerRef={scrollContainerRef} />
            </SettingsFullWidthContentLayout>
        </MaterialDefinitionsListProvider>
    );
};
